import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logo-alliage-favori',
  templateUrl: './logo-alliage-favori.component.html',
  styleUrls: ['./logo-alliage-favori.component.scss']
})
export class LogoAlliageFavoriComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
